// extracted by mini-css-extract-plugin
export default {"app":"app-ece1","appContent":"appContent-301c"};